// @flow
import React from 'react';

import type { ImplementationType, PaymentImpl } from '../index';
import type { Order, User } from "../../../../../entities";
import type { RootState } from "../../../../index";
import type { BillingAddressReq } from "../../api";

export default class PaymePayment implements PaymentImpl {
  type: ImplementationType = 'payme_usd';
  order: Order;
  user: User;
  
  setUpPayment(order: Order, dispatch: Function, rootState: RootState) {
    this.order = order;
    this.user = rootState.auth.user;
  }
  
  generateCustomUI() {
    if (!this.order || !this.order.invoice || !this.order.invoice.payment) {
      return null;
    }
    const paymentData = this.order.invoice.payment.paymentData;
    const address = this.order.shippingAddress;
    let descriptionProducts = [];
    const itemDescriptionLength = Math.floor(30 / this.order.items.length);
    for (let i of this.order.items) {
      descriptionProducts.push(i.name.substring(0, itemDescriptionLength));
    }
    return <form className="alignet-form-vpos2">
      <input type="hidden" name="acquirerId" value={paymentData.acquirerId}/>
      <input type="hidden" name="idCommerce" value={paymentData.commerceId}/>
      <input type="hidden" name="purchaseOperationNumber" value={paymentData.purchaseOperationNumber}/>
      <input type="hidden" name="purchaseAmount" value={paymentData.purchaseAmount}/>
      <input type="hidden" name="purchaseCurrencyCode" value={paymentData.purchaseCurrencyCode}/>
      <input type="hidden" name="language" value={paymentData.language}/>
      <input type="hidden" name="shippingFirstName" value={address.firstName}/>
      <input type="hidden" name="shippingLastName" value={address.lastName}/>
      <input type="hidden" name="shippingEmail" value={this.user.email}/>
      <input type="hidden" name="shippingAddress" value={`${address.address1} ${address.address2}`}/>
      <input type="hidden" name="shippingZIP" value={address.zipCode}/>
      <input type="hidden" name="shippingCity" value={address.admin2.name}/>
      <input type="hidden" name="shippingState" value={address.admin1.name}/>
      <input type="hidden" name="shippingCountry" value={address.country.code}/>
      <input type="hidden" name="userCommerce" value={this.user.id}/>
      <input type="hidden" name="userCodePayme" value/>
      <input type="hidden" name="descriptionProducts" value={descriptionProducts.join(',')}/>
      <input type="hidden" name="programmingLanguage" value="PYTHON"/>
      <input type="hidden" name="designID" value="3"/>
      <input type="hidden" name="typeDesign" value="Modal"/>
      {/*Reserved1 is being used for keeping the closed modal redirect relative url*/}
      <input type="hidden" name="reserved1" value={`/new-order/checkout/order/${this.order.id}`}/>
      <input type="hidden" name="purchaseVerification" value={paymentData.purchaseVerification}/>
    </form>
  }
  
  executeUIAction(billingAddress: BillingAddressReq, rootState: RootState) {
    if (!!window && !!window.AlignetVPOS2) {
      window.AlignetVPOS2.openModal("https://integracion.alignetsac.com/");
    }
  }
  
  showPopUp = (data: string) => undefined;
  
  clean = () => undefined;
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/PaymentImpl/Payme/index.js